module.exports = __webpack_public_path__ + "img/1538628785.5b2a71dc.jpg";